export default __webpack_public_path__ + "static/media/art-head.592ac798.jpg";